import React from 'react'
import { Image } from 'react-bootstrap';
import sideMenuLogo from '../../images/ergusLogo.png'

const KozmetikSideMenu = ({ handleMenuItemClick, activeMenuItem }) => {
    return (
        <div className="menu d-flex justify-content-center align-items-center flex-column">
            <ul>
                <li onClick={() => handleMenuItemClick('Leke Tedavisi')} className={activeMenuItem === 'Leke Tedavisi' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Leke Tedavisi
                </li>
                <li onClick={() => handleMenuItemClick('Cilt Bakımı')} className={activeMenuItem === 'Cilt Bakımı' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Cilt Bakımı
                </li>
                <li onClick={() => handleMenuItemClick('Kimyasal Peeling')} className={activeMenuItem === 'Kimyasal Peeling' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Kimyasal Peeling
                </li>
                <li onClick={() => handleMenuItemClick('Botox Uygulamaları')} className={activeMenuItem === 'Botox Uygulamaları' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Botox Uygulamaları
                </li>
                <li onClick={() => handleMenuItemClick('Dolgu Uygulamaları')} className={activeMenuItem === 'Dolgu Uygulamaları' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Dolgu Uygulamaları
                </li>
                <li onClick={() => handleMenuItemClick('PRP Uygulamaları')} className={activeMenuItem === 'PRP Uygulamaları' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    PRP Uygulamaları
                </li>
                <li onClick={() => handleMenuItemClick('Mezoterapi Uygulamaları')} className={activeMenuItem === 'Mezoterapi Uygulamaları' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Mezoterapi Uygulamaları
                </li>
                <li onClick={() => handleMenuItemClick('Dermoroller Uygulamaları')} className={activeMenuItem === 'Dermoroller Uygulamaları' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Dermoroller Uygulamaları
                </li>
                <li onClick={() => handleMenuItemClick('PDO İpleri ve Cilt Germe')} className={activeMenuItem === 'PDO' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    PDO İpleri ve Cilt Germe
                </li>
            </ul>
        </div>
    );
};

export default KozmetikSideMenu;